import { useContext } from "react";
import { SearchContext } from "./SearchContext";
import type { ISearchData } from "./ISearchData";

export function useSearch(): ISearchData {
  const context = useContext(SearchContext);

  if (context == null) {
    throw new Error("useSearch must be used within a SearchProvider");
  }

  return context;
}
